module.exports = __webpack_public_path__ + "static/img/news-20221215.6eacd9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20221215.png
// module id = XYAH
// module chunks = 0